module.exports = __webpack_public_path__ + "static/branding-3-19cd7ae60682d48c73a48047b7413fc5.jpg";